<template>
    <PlanbordGridCell class="weekCell" :style="cssStyle" noPadding :title="weekLabel">
        <div class="week">
            <span class="weekText">{{ weekLabel }}</span>
        </div>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import Dates from '@cquential/date-utils';
    import {Week} from '@/types';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class RosterWeek extends Vue {
        @Prop({required: true}) public week!: Week;
        @Prop({type: Date, required: true}) public firstVisibleDate!: Date;

        public get weekLabel(): string {
            return this.week.weekNumber.toString();
        }

        public get cssStyle(): Partial<CSSStyleDeclaration> {
            const startDate: Date = Dates.Utils.max(this.week.beginDate, this.firstVisibleDate);
            const start: number = Dates.Utils.diffInDays(startDate, this.firstVisibleDate) + 1;
            const span: number = Dates.Utils.diffInDays(this.week.endDate, startDate) + 1;

            return {
                gridColumn: start + ' / span ' + span,
            };
        }
    }
</script>

<style lang="scss" scoped>
    .weekCell {
        border: 1px solid var(--cell-border-color);
        width: calc(100% + 1px);
        margin-left: -1px;
        margin-top: -1px;

        .week {
            display: flex;
            height: 100%;
            max-width: 100%;
            align-items: center;
            justify-content: center;
            box-shadow: inset 0.25rem 0 0 0 var(--week-side-marker-color), inset -0.25rem 0 0 0 var(--week-side-marker-color);
            padding: var(--cell-padding);
            margin-inline: var(--cell-padding);

            .weekText {
                white-space: nowrap;
                overflow: hidden;
            }
        }
    }

</style>
